import React from "react"

const FixedImage = () => {
  return (
    <section>
      <div className="container-fluid pb-5">
        <div className="row py-5">
          <div className="col-12 fixed__image"></div>
        </div>
      </div>
    </section>
  )
}

export default FixedImage
